import React, { Component } from 'react';
import loadable from 'src/common/loadable';
import { getText } from 'src/utils/i18n';
import PropTypes from 'prop-types';
import './index.scss';

const AsyncGlpForm = loadable(() => import('./glp-form'), {
  loadingVisible: false,
});

export default class GLP extends Component {
  static propTypes = {
    product: PropTypes.object,
    seller: PropTypes.object,
    i18n: PropTypes.object,
    detailEncryptId: PropTypes.string,
    language: PropTypes.string,
    uniqueToken: PropTypes.string,
    hostToken: PropTypes.string,
    // productIsMarketGoods: PropTypes.bool,
    // productLadderPrices: PropTypes.array,
    // sku: PropTypes.object,
  };

  state = {
    renderForm: false,
  };

  componentDidMount() {
    setTimeout(() => {
      this.initForm();
    }, 2000);
  }

  initForm() {
    this.setState({
      renderForm: true,
    });
  }

  render() {
    const {
      i18n,
      seller = {},
      product = {},
      detailEncryptId,
      language,
      uniqueToken,
      hostToken,
    } = this.props;
    const { productIsMarketGoods, sku = {}, price = {}, productId } = product;
    const { productLadderPrices = [] } = price;
    const { renderForm } = this.state;

    const {
      baoAccountIsService,
      baoAccountIsDisplayAssurance,
      sellerSelfOperated,
    } = seller;
    const domdot = {
      glp: 'id:3303,ext:',
      domDotExt: `is_xinbao_product=${
        baoAccountIsService ? 1 : 0
      }|is_display_assurance=${baoAccountIsDisplayAssurance ? 1 : 0}`,
    };

    const { skuAttrs = [] } = sku;
    // 有阶梯价及属性的询盘品没有GLP
    if (
      productIsMarketGoods ||
      (productLadderPrices.length > 0 && skuAttrs.length > 0) ||
      sellerSelfOperated
    )
      return null;

    return (
      <div className="ma-fob-title detail-mainscreen-center-grid">
        FOB{' '}
        <span
          dangerouslySetInnerHTML={{
            __html: getText(
              i18n,
              'mainAction_fob_glp',
              '<b>Reference</b> Price:',
            ),
          }}
        />
        <a
          id="J-get-last-price"
          className="ma-glp"
          data-domdot={`${domdot.glp}${domdot.domDotExt}`}
          rel="nofollow"
        >
          {getText(i18n, 'mainAction_fob_glp_link', 'Get Latest Price')}
        </a>
        {renderForm ? (
          <AsyncGlpForm
            productId={productId}
            detailEncryptId={detailEncryptId}
            language={language}
            uniqueToken={uniqueToken}
            hostToken={hostToken}
          />
        ) : null}
      </div>
    );
  }
}
